import { IMAGE_REQUEST, IMAGE_SUCCESS, IMAGE_FAILURE } from "../actions/types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const ImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMAGE_REQUEST:
      return { ...state, loading: true, error: null };
    case IMAGE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case IMAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default ImageReducer;
